<template>
	<div>
		<BusinessBanner />
		<div class="content-zsy">
			<div class="widget-location">
				<h3>대리결제</h3>
			</div>

			<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
				<el-tab-pane name="first">
				    <div class="tab-pane" slot="label">대리결제 송금 인보이스 신청</div>
				    <div class="article mt50">
						<div class="document-sub-tit">송금</div>
						<div class="document-des mb20">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<circle cx="12" cy="12" r="12" fill="#274A80"></circle>
								<path d="M13.4408 14.417H11.3158L11.1 6H13.6566L13.4408 14.417ZM12.3949 18.1689C12.1403 18.1689 11.9051 18.1053 11.6893 17.978C11.4735 17.8507 11.302 17.682 11.1747 17.4717C11.0529 17.2559 10.9948 17.0234 11.0004 16.7744C10.9948 16.5254 11.0529 16.2957 11.1747 16.0854C11.302 15.8752 11.4735 15.7091 11.6893 15.5874C11.9051 15.4601 12.1403 15.3965 12.3949 15.3965C12.6328 15.3965 12.857 15.4601 13.0673 15.5874C13.2831 15.7091 13.4546 15.8752 13.5819 16.0854C13.7092 16.2957 13.7728 16.5254 13.7728 16.7744C13.7728 17.0234 13.7092 17.2559 13.5819 17.4717C13.4546 17.682 13.2831 17.8507 13.0673 17.978C12.857 18.1053 12.6328 18.1689 12.3949 18.1689Z" fill="white"></path>
							</svg>
							자세한 이용방법 바로가기를 통해 확인해주세요.
							<div>
								<a href="/payGuide" class="link-btn type-1">바로가기
									<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M5.21804 1.94271H1.49471C1.3179 1.94271 1.14833 1.87247 1.0233 1.74745C0.898279 1.62243 0.828041 1.45286 0.828041 1.27604C0.828041 1.09923 0.898279 0.929664 1.0233 0.80464C1.14833 0.679616 1.3179 0.609378 1.49471 0.609378H6.82804C6.91566 0.609114 7.00247 0.626178 7.08348 0.659587C7.16448 0.692997 7.23808 0.742093 7.30003 0.804051C7.36199 0.86601 7.41109 0.939607 7.4445 1.02061C7.47791 1.10161 7.49497 1.18842 7.49471 1.27604V6.60938C7.49471 6.78619 7.42447 6.95576 7.29945 7.08078C7.17442 7.20581 7.00485 7.27604 6.82804 7.27604C6.65123 7.27604 6.48166 7.20581 6.35664 7.08078C6.23161 6.95576 6.16137 6.78619 6.16137 6.60938V2.88538L1.64204 7.40471C1.51695 7.52972 1.34732 7.59991 1.17047 7.59985C0.993625 7.59978 0.824047 7.52947 0.699041 7.40438C0.574036 7.27928 0.503844 7.10966 0.503906 6.93281C0.503969 6.75596 0.574281 6.58638 0.699375 6.46138L5.21804 1.94271V1.94271Z" fill="white"></path>
									</svg>
								</a>
							</div>
						</div>
						<ul>
							<li>
								<img src="../../assets/list/invoice-write-icon1.png" alt="인보이스 신청" loading="lazy">
								<span>인보이스 신청</span>
							</li>
							<li>
								<img class="arrow" src="../../assets/list/invoice-write-arrow.png" loading="lazy">
							</li>
							<li>
								<img src="../../assets/list/invoice-write-icon2.png" alt="인보이스 발행" loading="lazy">
								<span>인보이스 발행(메일)</span>
							</li>
							<li>
								<img class="arrow" src="../../assets/list/invoice-write-arrow.png" loading="lazy">
							</li>
							<li>
								<img src="../../assets/list/invoice-write-icon3.png" alt="은행송금" loading="lazy">
								<span>은행송금</span>
							</li>
							<li>
								<img class="arrow" src="../../assets/list/invoice-write-arrow.png" loading="lazy">
							</li>
							<li>
								<img src="../../assets/list/invoice-write-icon1.png" alt="1:1 문의로 송금중 접수" loading="lazy">
								<span>1:1 문의로 송금중 접수</span>
							</li>
							<li>
								<img class="arrow" src="../../assets/list/invoice-write-arrow.png" loading="lazy">
							</li>
							<li>
								<img src="../../assets/list/invoice-write-icon1.png" alt="상품대금 충전완료" loading="lazy">
								<span>상품대금 충전완료</span>
							</li>
						</ul>	
					</div>
					<div class="article mt50">
						<div class="document-sub-tit">신청서 작성</div>
						<div class="document-des">사업자 정보와 구매할 상품정보를 작성하여 신청해 주십시오. 인보이스를 발행하여 이메일로 전송해 드립니다.</div>
						<el-form
							ref="dynamicForm" 
							:model="formData" 
							label-width="110px"
						>
							<el-row>
								<el-col :xs="24" :sm="12">
									<el-form-item
									  :label="'영문상호'"
									  prop="company"
									  :rules="[
										{ required: true, message: '영문상호 필수', trigger: 'change' },
									  ]">
										<div class="flex">
											<el-input v-model="formData.data.company"  ></el-input>
										</div>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="12">
									<el-form-item
									  :label="'영문주소'"
									  prop="address"
									  :rules="[
										{ required: true, message: '영문주소 필수', trigger: 'change' },
									  ]">
										<div class="flex">
											<el-input v-model="formData.data.address"  ></el-input>
										</div>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="12">
									<el-form-item
									  :label="'이메일'"
									  prop="mail"
									  :rules="[
										{ required: true, message: '이메일 필수', trigger: 'change' },
									  ]">
										<div class="flex">
											<el-input v-model="formData.data.mail"  ></el-input>
										</div>
									</el-form-item>
								</el-col>
							</el-row>
							
							<div class="goods-info" style="">
								상품정보
							</div>
							<div
								v-for="(item, index) in formData.items" 
								:key="item.id" >
								<el-row>
									<el-col :xs="24" :sm="8">
										<el-form-item
										  :label="`상품명${index+1}`"
										  :prop="`items.${index}.goods_name`"
										  :rules="[
											{ required: true, message: '상품명 필수', trigger: 'blur' },
										  ]"
										>
											<div class="flex">
												<el-input v-model="item.goods_name"  clearable ></el-input>
											</div>						  
										</el-form-item>
									</el-col>
									<el-col :xs="24" :sm="8">
										<el-form-item
										  :label="'수량'"
										  :prop="`items.${index}.quantity`"
										  :rules="[
											{ required: true, message: '수량 필수', trigger: 'blur' },
										  ]"
										>
											<div class="flex">
												<el-input v-model="item.quantity" type="number" clearable ></el-input>
											</div>						  
										</el-form-item>
									</el-col>
									<el-col :xs="24" :sm="8">
										<el-form-item
										  :label="'단가($)'"
										  :prop="`items.${index}.price`"
										  :rules="[
											{ required: true, message: '단가($) 필수', trigger: 'blur' },
										  ]"
										>
											<div class="flex">
												<el-input v-model="item.price" type="number" clearable ></el-input>
											</div>						  
										</el-form-item>
									</el-col>
								</el-row>
								
							</div>
							
							<div style="padding:10px 0 20px 0; display: flex;justify-content:space-between;">
								<div class="total-price">
									${{totalAmount.toFixed(2)}}
								</div>
								<div>
									<el-button
										type="info" 
										icon="el-icon-plus" 
										@click="addItem"
									>
										상품추가
									</el-button>
									<el-button 
										@click="resetItem"
									>
										초기화
									</el-button>
								</div>
							</div>

						</el-form>
						<div class="text-center">
							<el-button
							  type="primary" 
							  @click="submitForm" round
							  style="margin-bottom: 10px"
							>
							  인보이스 신청
							</el-button>
						</div>
								
					</div>
					<div class="article mt50">
						<div class="text-box">
							<h3>해외송금 방식</h3>
							<ol>
								<li>은행을 통한 송금 혹은 고로켓고 제휴업체를 통한 송금
									<a href="/partnership" class="link-btn type-1">바로가기
										<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M5.21804 1.94271H1.49471C1.3179 1.94271 1.14833 1.87247 1.0233 1.74745C0.898279 1.62243 0.828041 1.45286 0.828041 1.27604C0.828041 1.09923 0.898279 0.929664 1.0233 0.80464C1.14833 0.679616 1.3179 0.609378 1.49471 0.609378H6.82804C6.91566 0.609114 7.00247 0.626178 7.08348 0.659587C7.16448 0.692997 7.23808 0.742093 7.30003 0.804051C7.36199 0.86601 7.41109 0.939607 7.4445 1.02061C7.47791 1.10161 7.49497 1.18842 7.49471 1.27604V6.60938C7.49471 6.78619 7.42447 6.95576 7.29945 7.08078C7.17442 7.20581 7.00485 7.27604 6.82804 7.27604C6.65123 7.27604 6.48166 7.20581 6.35664 7.08078C6.23161 6.95576 6.16137 6.78619 6.16137 6.60938V2.88538L1.64204 7.40471C1.51695 7.52972 1.34732 7.59991 1.17047 7.59985C0.993625 7.59978 0.824047 7.52947 0.699041 7.40438C0.574036 7.27928 0.503844 7.10966 0.503906 6.93281C0.503969 6.75596 0.574281 6.58638 0.699375 6.46138L5.21804 1.94271V1.94271Z" fill="white"></path>
										</svg>
									</a>
								</li>
								<li>최초 1회 송금 시 은행에 직접 방문하여 송금을 해주셔야 합니다. 이후 송금은 인터넷 뱅킹으로 가능합니다.<br>다만 송금 시 반드시 사업자 공인인증서를 발급받으셔서 기업뱅킹 서비스를 신청/등록하신 뒤 사업자로 로그인하셔야 온라인을 통한 사업자 송금이 가능합니다.</li>
							</ol>
							<h3>해외송금 시 주의사항</h3>
							<ol>
								<li>반드시 포스트 팀 홈페이지에서 인보이스 신청을 해주셔야 합니다.</li>
								<li>포스트 팀 현지 협력 법인의 진출구 계좌가 변경이 될 수 있기 때문에 임의로 인보이스를 작성하여 송금을 하시면 절대 안됩니다.</li>
								<li>임의로 인보이스 작성하여 송금하실 경우 송금하신 무역대금 은 포스트 팀에서 책임지지 않습니다.</li>
								<li>사업자 사전 무역대금 송금으로 송금하셔야 합니다.</li>
								<li>국내은행에서 중국은행으로 송금 시 송금 수수료는 모두 한국 발송자 부담으로 해주시기 바랍니다.</li>
								<li>수취인 부담으로 할 경우 보낸 금액에서 차감되어 처리됩니다.</li>
								<li>송금 시 보내시는 분 이름은 반드시 영문 사업자로 진행해 주시기 바랍니다.</li>
								<li>송금 계좌 정보 오류로 인한 문제는 포스트 팀에서 책임지지 않습니다.</li>
							</ol>
						</div>
					</div>
					
				</el-tab-pane>
				<el-tab-pane name="second">
				    <div class="tab-pane" slot="label">대리결제 송금 인보이스 내역</div>
				    <div class="list-top">
				    	<div class="page-info">
				    		<span>전체 : <strong>{{invoice_total}}</strong> ( {{invoice_current_page}} / {{invoice_last_page}} 페이지 )</span>
				    	</div>
				    </div>
					<el-table
						    :data="invoice_list"
						    stripe empty-text="데이타가 없습니다."
						    style="width: 100%">
					<!-- 	    <el-table-column
						      type="index"
						      label="순번"
						      width="80">
						    </el-table-column> -->
							<el-table-column
							  label="내역">
									<template slot-scope="scope">	     
										<i class="el-icon-s-promotion"></i> 
							            <span style="cursor:pointer;" > {{ scope.row.title }}</span>				           
							        </template>
							</el-table-column>
							<el-table-column
							  prop="deposit"
							  label="사용위안화"
							  width="200">
							</el-table-column>
							<el-table-column
							  prop="deposit"
							  label="누적위안화"
							  width="200">
							</el-table-column>
							<el-table-column
							  prop="createtime"
							  label="등록일"
							  width="150">
							</el-table-column>
						</el-table>
						<div class="page">
							<el-pagination
								layout="prev, pager, next" :page-size="20"
								:total="invoice_total"  @current-change="handleInvoiceCurrentChange">
							</el-pagination>
						</div>
					
					
					
				</el-tab-pane>
				<el-tab-pane name="third">
					<div class="tab-pane" slot="label">대리결제 요청</div>
					<div style="margin: 0 10px;" v-if="!isMobile" >
		
						<p class="agency-payment-request-desc">구매처 쇼핑몰 혹은 제조공장 중 1가지만 입력하세요.</p>
						<p class="agency-payment-request-divide"><span>* 구매처가 쇼핑몰일 경우 입력</span><span>* 구매처가 제조공장일 경우 입력</span></p>
						<el-form
							ref="agent" 
							:model="agentData" 	
						>
							<el-row>
								<el-col :span="2" class="th-center">번호</el-col>
								<el-col :span="5" class="th-center">쇼핑몰 아이디</el-col>
								<el-col :span="5" class="th-center">주문번호</el-col>
								<el-col :span="5" class="th-center">제조공장,회사명(중문)</el-col>
								<el-col :span="5" class="th-center">제조공장,회사연락처</el-col>
								<el-col :span="2" class="th-center">금액</el-col>
							</el-row>
							<div
								v-for="(item, index) in agentData.items" 
								:key="index" >
								<el-row>
									<el-col :span="2" style="text-align: center; height: 40px;line-height: 40px;">{{index+1}}</el-col>
									<el-col :span="5">
										<el-form-item
										  :prop="`items.${index}.id`"
										>										
											<el-input v-model="item.id" style="width: 90%;" clearable ></el-input>				  
										</el-form-item>
									</el-col>
									<el-col :span="5">
										<el-form-item
										  :prop="`items.${index}.order_no`"
										>										
											<el-input v-model="item.order_no" style="width: 90%;"  clearable ></el-input>				  
										</el-form-item>
									</el-col>
									<el-col :span="5">
										<el-form-item
										  :prop="`items.${index}.company_name`"
										>										
											<el-input v-model="item.company_name" style="width: 90%;" clearable ></el-input>				  
										</el-form-item>
									</el-col>
									<el-col :span="5">
										<el-form-item
										  :prop="`items.${index}.company_tel`"
										>										
											<el-input v-model="item.company_tel" style="width: 90%;" clearable ></el-input>				  
										</el-form-item>
									</el-col>
									<el-col :span="2">
										<el-form-item
										  :prop="`items.${index}.price`"
										  :rules="[
										  		{ required: true, message: '금액 필수', trigger: 'blur' },
										  ]"
										>										
											<el-input v-model="item.price" type="number" clearable ></el-input>				  
										</el-form-item>
									</el-col>
								</el-row>
							</div>

							<div style="padding:10px 0 20px 0; display: flex;justify-content:space-between;">
								<div class="total-price">
									¥{{agentAmount.toFixed(2)}}
								</div>
								<div>
									<el-button
										type="info" 
										icon="el-icon-plus" 
										@click="addAgentItem"
									>
										주문추가
									</el-button>
									<el-button 
										@click="resetAgentItem"
									>
										초기화
									</el-button>
								</div>
							</div>
						</el-form>
						<div class="text-center">
							<el-button
							  type="primary" 
							  @click="submitAgentForm" round
							  style="margin-bottom: 10px"
							>
								대리결제 요청하기
							</el-button>
						</div>
					</div>
				    <div style="margin: 0 10px;" v-else >
				    		
				    	<p class="agency-payment-request-desc">구매처 쇼핑몰 혹은 제조공장 중 1가지만 입력하세요.</p>
				    	
				    	<el-form
				    		ref="agent" 
				    		:model="agentData" 	
				    	>
				    		
				    		<div
				    			v-for="(item, index) in agentData.items" 
				    			:key="index" >
								<p class="agency-payment-request-divide">* 구매처가 쇼핑몰일 경우 입력</p>
								<el-row>
									<el-col :span="4" class="th-center">번호</el-col>
									<el-col :span="10" class="th-center">쇼핑몰 아이디</el-col>
									<el-col :span="10" class="th-center">주문번호</el-col>
					
								</el-row>
				    			<el-row>
				    				<el-col :span="4" style="text-align: center; height: 40px;line-height: 40px;">{{index+1}}</el-col>
				    				<el-col :span="10">
				    					<el-form-item
				    					  :prop="`items.${index}.id`"
				    					>										
				    						<el-input v-model="item.id" style="width: 90%;" clearable ></el-input>				  
				    					</el-form-item>
				    				</el-col>
				    				<el-col :span="10">
				    					<el-form-item
				    					  :prop="`items.${index}.order_no`"
				    					>										
				    						<el-input v-model="item.order_no" style="width: 90%;"  clearable ></el-input>				  
				    					</el-form-item>
				    				</el-col>
				    				
				    			</el-row>
								<p class="agency-payment-request-divide">* 구매처가 제조공장일 경우 입력</p>
								<el-row>
									<el-col :span="4" class="th-center">금액</el-col>
									<el-col :span="10" class="th-center">제조공장,회사명(중문)</el-col>
									<el-col :span="10" class="th-center">제조공장,회사연락처</el-col>
									
								</el-row>
								<el-row>
									<el-col :span="4">
										<el-form-item
										  :prop="`items.${index}.price`"
										  :rules="[
										  		{ required: true, message: '금액 필수', trigger: 'blur' },
										  ]"
										>										
											<el-input v-model="item.price" type="number" clearable ></el-input>				  
										</el-form-item>
									</el-col>
									<el-col :span="10">
										<el-form-item
										  :prop="`items.${index}.company_name`"
										>										
											<el-input v-model="item.company_name" style="width: 90%;" clearable ></el-input>				  
										</el-form-item>
									</el-col>
									<el-col :span="10">
										<el-form-item
										  :prop="`items.${index}.company_tel`"
										>										
											<el-input v-model="item.company_tel" style="width: 90%;" clearable ></el-input>				  
										</el-form-item>
									</el-col>
									
								</el-row>
								
								
				    		</div>
				    
				    		<div style="padding:10px 0 20px 0; display: flex;justify-content:space-between;">
				    			<div class="total-price">
				    				¥{{agentAmount.toFixed(2)}}
				    			</div>
				    			<div>
				    				<el-button
				    					type="info" 
				    					icon="el-icon-plus" 
				    					@click="addAgentItem"
				    				>
				    					주문추가
				    				</el-button>
				    				<el-button 
				    					@click="resetAgentItem"
				    				>
				    					초기화
				    				</el-button>
				    			</div>
				    		</div>
				    	</el-form>
				    	<div class="text-center">
				    		<el-button
				    		  type="primary" 
				    		  @click="submitAgentForm" round
				    		  style="margin-bottom: 10px"
				    		>
				    			대리결제 요청하기
				    		</el-button>
				    	</div>
				    </div>
					
					
				</el-tab-pane>
				<el-tab-pane name="fourth">
				    <div class="tab-pane" slot="label">대리결제 요청 내역</div>
				    <div class="list-top">
				    	<div class="page-info">
				    		<span>전체 : <strong>{{agent_total}}</strong> ( {{agent_current_page}} / {{agent_last_page}} 페이지 )</span>
				    	</div>
				    </div>
					<el-table
						    :data="agent_list"
						    stripe empty-text="데이타가 없습니다."
						    style="width: 100%">
							<el-table-column
							  type="index"
							  label="번호"
							  width="80">
							</el-table-column>
							<el-table-column
							  label="쇼핑몰 아이디">
									<template slot-scope="scope">
							            <span style="cursor:pointer;" > {{ scope.row.id }}</span>				           
							        </template>
							</el-table-column>
							<el-table-column
							  prop="order_no"
							  label="주문번호"
							  >
							</el-table-column>
							<el-table-column
							  prop="company_name"
							  label="제조공장,회사명(중문)"
							  >
							</el-table-column>
							<el-table-column
							  prop="company_tel"
							  label="제조공장,회사연락처"
							  >
							</el-table-column>
							<el-table-column
							  prop="price"
							  label="금액"
							  width="150">
							</el-table-column>
							<el-table-column
							  prop="createtime"
							  label="등록일"
							  width="200">
							</el-table-column>
						</el-table>
						<div class="page">
							<el-pagination
								layout="prev, pager, next" :page-size="20"
								:total="agent_total"  @current-change="handleAgentCurrentChange">
							</el-pagination>
						</div>
					
					
				</el-tab-pane>
	
			</el-tabs>
		</div>

	</div>
</template>

<script>
	import BusinessBanner from '../../components/BusinessBanner.vue'
	export default {
		components: {
			BusinessBanner,
		},
		data() {
			return{
				activeName: 'first',
				formData: {
					items: [], // 动态表单项数组
					data:{
						company:"",
						address:'',
						mail:'',
					}				
				},
				invoice_total:0,
				invoice_page:1,
				invoice_current_page:1,
				invoice_last_page:1,
				invoice_list: [],
				agentData:{
					items: [],	
				},
				agent_total:0,
				agent_page:1,
				agent_current_page:1,
				agent_last_page:1,
				agent_list: [],
				 
			}
		},
		computed: {
			/**
			* 计算总金额：所有商品的（单价 × 数量）之和
			*/
			totalAmount() {
				return this.formData.items.reduce((sum, goods) => {
					// 处理未输入的情况（默认0）
					const price = Number(goods.price) || 0
					const quantity = Number(goods.quantity) || 0
					return sum + (price * quantity)
				}, 0)
			},
			//代付总金额
			agentAmount(){
				return this.agentData.items.reduce((sum, goods) => {
					const price = Number(goods.price) || 0
					return sum + price
				}, 0)
			},
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},	
		created() {
			
			this.addItem()
			this.addAgentItem()
		},
		methods: {
			handleAgentCurrentChange(){
				console.log(`当前页: ${val}`);
				this.agent_page = val
				this.getAgentList()
			},
			getAgentList(){
				console.log("第四个")	
				
			},
			handleInvoiceCurrentChange(val) {
			    console.log(`当前页: ${val}`);
				this.invoice_page = val
				this.getInvoiceList()
			},
			getInvoiceList(){
				console.log("第二个")
				
			},
			handleClick(tab, event) {
		        console.log(tab,"11111");
				//console.log(event,"22222");
				if(tab.name == "first"){
					
				}else if(tab.name == "second"){
					this.getInvoiceList()
				}else if(tab.name == "third"){
					
				}else if(tab.name == "fourth"){
					
				}
		    },
			addItem(){
				this.formData.items.push({
					goods_name:'',
					quantity:'',
					price:'',				
				})
			},
			addAgentItem(){
				this.agentData.items.push({
					id:'',
					order_no:'',
					company_name:'',
					company_tel:'',
					price:'',
				})
			},
			resetItem(){
				this.formData.items=[{
					goods_name:'',
					quantity:'',
					price:'',				
				}]
			},
			resetAgentItem(){
				this.agentData.items=[{
					id:'',
					order_no:'',
					company_name:'',
					company_tel:'',
					price:'',				
				}]
			},
			submitForm() {
				this.$refs.dynamicForm.validate((valid) => {
					if (valid) {
						
						
					} else {
					  // 表单验证失败
					  this.$message.error('작성된 내용을 확인하십시오.')
					  return false
					}
				})
			},
			submitAgentForm(){
				
				this.$refs.agent.validate((valid) => {
					if (valid) {
						console.log("Agent 提交")
						
					} else {
					  // 表单验证失败
					  this.$message.error('작성된 내용을 확인하십시오.')
					  return false
					}
				})
			},
		},
		
	}
</script>

<style scoped>
	.widget-location {
	    margin-top: 50px;
	    margin-bottom: 60px;
	    text-align: center;
	}
	.widget-location h3 {
	    padding: 0;
	    margin: 0;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	}
	.tab-pane{
		font-size: 14px;text-align:center;padding:0 20px;font-weight: bold;
	}
	.article{
		margin:0 10px;
	}
	.document-sub-tit {
	    font-size: 30px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    margin-bottom: 15px;
	}
	.article:nth-child(1) .document-des {
	    display: flex;
	    gap: 10px;
	    align-items: center;
	    background: #F5F8FD;
	    border-radius: var(--border-radius);
	    font-size: 17px;
	    font-weight: bold;
	    color: #274A80;
	    padding: 14px 24px;
	}
	.article .document-des a {
	    width: 77px;
	    height: 26px;
	    padding: 0;
	    font-size: 13px;
	    font-weight: 600;
	    gap: 4px;
	}
	.link-btn {
	    display: inline-flex;
	    justify-content: center;
	    align-items: center;
	    border-radius: 19px;
	    font-weight: 600;
	    font-size: 12px;
	    text-transform: uppercase;
	    text-decoration: none !important;
	    border: 1px solid var(--main-color);
	    padding: 7px 17px;
	    transition: 0.25s;
	    line-height: normal;
	}
	.link-btn.type-1 {
	    color: #fff;
	    background: var(--main-color);
	}
	.article ul {
	    margin: 0;
	    padding: 50px 70px 47px;
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    background: #F8F8F8;
	    border-radius: var(--border-radius);
	    border: 1px solid var(--border-color);
	    list-style-type: none;
	}
	.article ul li {
	    display: flex;
	    flex-direction: column;
	    justify-content: center;
	    align-items: center;
	    gap: 8px;
	    font-size: 17px;
	    font-weight: bold;
	    color: rgba(0, 0, 0, 0.8);
	}
	.article .document-des {
	    font-size: 17px;
	    font-weight: 500;
	    color: var(--frontground-color);
	    margin-bottom: 17px;
	}
	.total-price{
		font-size: 24px;font-weight: bold;color: #0066ff !important;
	}
	.goods-info{
		font-size: 20px;font-weight: bold;padding:0 0 10px 3%;
	}
	.text-box {
	    padding: 31px 50px 50px;
		color: var(--background-color);
	    background: #fff;
	    border: 1px solid #D9D9D9;
	    border-radius: var(--border-radius);
	}
	.text-box h3 {
	    font-weight: bold;
	    font-size: 24px;
	    margin-bottom: 20px;
	}
	.text-box ol {
	    font-size: 17px;
	    font-weight: 500;
	    line-height: 32px;
	    padding: 0 0 0 23px;
	    margin: 0;
	}
	.list-top {
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    margin: 40px 0 30px;
		padding:0 10px;
	}
	.page{
		padding-top: 20px;
		text-align: center;
	}
	.agency-payment-request-desc {
	    color: var(--frontground-color);
	    font-weight: 500;
	    margin-top: 40px;
	    margin-bottom: 37px;
	}
	.agency-payment-request-divide {
	    font-size: 15px;
	    font-weight: bold;
	    color: var(--main-color);
	    padding-left: 100px;
	    margin-bottom: 6px;
	}
	.agency-payment-request-divide span:first-child {
	    display: inline-block;
	    width: 520px;
	}
	.th-center{
		text-align: center;padding-bottom: 10px;
	}
	
	
	.mt50 {
	    margin-top: 50px !important;
	}
	.mb20 {
	    margin-bottom: 20px !important;
	}
	.text-center {
	    text-align: center !important;
	}
	::v-deep .el-table__header th {
		color: #333; 
		font-size: 13px;
		font-weight: bold;
	}
	img {
	    vertical-align: middle;
		border: 0;
	}
	/* 分页背景 */
	::v-deep .el-pager li {
		background-color: #121212;
	}
	::v-deep .el-pagination button:disabled {
		background-color: #121212;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.article:nth-child(1) .document-des {
			font-size: 15px;
		}
		.article ul {
		    list-style-type: none;
		    padding: 30px 20px;
		    margin: 0 0 30px 0;
		    display: grid;
		    grid-template-columns: repeat(3, 1fr);
		    background: #F8F8F8;
		    border-radius: var(--border-radius);
		    border: 1px solid var(--border-color);
		}
		.article li .arrow {
		    width: 30px;
		    height: auto;
		}
		.article ul li {
		    display: flex;
		    flex-direction: column;
		    justify-content: center;
		    align-items: center;
		}
		.article ul li img {
		    width: 70px;
		    height: 70px;
		}
		.article ul li span {
		    font-size: 13px;
		    font-weight: bold;
		    white-space: nowrap;
		    margin-top: 6px;
		}
		.article ul li:nth-child(4), .article ul li:nth-child(8) {
		    transform: rotate(145deg);
		    margin: 10px 0;
		}
		.article ul li:nth-child(4),  .article ul li:nth-child(8),.article ul li:nth-child(9) {
		    grid-column: 1 / -1;
		}
		.document-sub-tit {
			font-size: 17px;
			font-weight: bold;
			margin-bottom: 8px;
		}
		.article .document-des {
		    font-size: 13px;
		    font-weight: 500;
		    color: rgba(0, 0, 0, 0.8);
		    margin-bottom: 10px;
		}
		.goods-info{
			font-size: 20px;font-weight: bold;padding:0 0 10px 12%;
		}
		
	}
</style>